package com.tixforgigs.common.http


import com.tixforgigs.apax.models.*
import kotlin.uuid.Uuid

sealed class ApiGetPath {

  data class Events(
    val dbVersion: Long,
    val page: Int? = null,
    val size: Int? = null,
  ) : ApiGetPath()

  data class EventById(val eventId: Int) : ApiGetPath()
  data class EventsByTemplateId(
    val templateId: Uuid,
    val details: Boolean = false,
    val page: Int = 0,
    val size: Int = 24,
    val sort: List<String>? = null
  ) : ApiGetPath()

  data class Orders(
    val dbVersion: Long = 0,
    val details: Boolean = false,
    val page: Int = 0,
    val size: Int = 24,
    val sort: List<String>? = null,
  ) : ApiGetPath()

  data class OrderById(val orderId: Int, val orderToken: String?) : ApiGetPath()

  data class Tickets(
    val eventId: Int? = null,
    val contingentId: Int? = null,
    val venueId: Int? = null,
    val promoterId: String? = null,
    val dbVersion: Long = 0,
    val page: Int = 0,
    val size: Int = 24,
    val sort: List<String>? = null,
  ) : ApiGetPath()

  class Invoice(val orderId: Int, val invoiceId: Int, val orderToken: String?) : ApiGetPath()

  data object Profile : ApiGetPath()

  data class TicketResaleConfig(val ticketId: Int) : ApiGetPath()

  data object TemplateConfigs : ApiGetPath()
  data class TemplateConfigByTemplateId(val templateId: Uuid) : ApiGetPath()
  data class TemplateFilterSearch(val searchText: String, val searchType: FilterSearchType) : ApiGetPath()
  data class TemplateStyle(val templateId: Uuid) : ApiGetPath()
  data object SystemCountries : ApiGetPath()
}

sealed class ApiPostPath {
  data class CartCreate(val body: CartMetaInfo) : ApiPostPath()
  data class CartAdd(val body: ItemAddRequest) : ApiPostPath()
  data class CartRemove(val body: ItemRemoveRequest) : ApiPostPath()
  data class CartRefresh(val body: CartRefreshRequest) : ApiPostPath()
  data class CartOptions(val body: CartOptionsRequest) : ApiPostPath()
  data class CartFloorplanBestAvailable(val body: BestAvailableRequest) : ApiPostPath()
  data class CartAddVoucher(val body: VoucherRequest) : ApiPostPath()
  data class CartRemoveVoucher(val body: VoucherRequest) : ApiPostPath()

  data class OrderCreate(val body: OrderRequest) : ApiPostPath()
  data class OrderRestart(val orderId: Int, val orderToken: String, val body: OrderRestartRequest) : ApiPostPath()
  data class OrderApprove(val orderId: Int, val orderToken: String, val body: OrderApproveRequest) : ApiPostPath()

  data class TemplateConfigCreate(val body: TemplateCreateRequest) : ApiPostPath()
  data class TemplateConfigUpdate(val templateId: Uuid, val body: TemplateConfig) : ApiPostPath()
  data class AccountLogin(val body: TokenAuthRequest) : ApiPostPath()
  data class AuthToken(val body: GrantRequest) : ApiPostPath()

  data class AccountAddressCreate(val body: Address) : ApiPostPath()
  data class AccountBankDetailsCreate(val body: BankAccount) : ApiPostPath()
  data class AccountPasswordReset(val body: ResetPasswordRequest) : ApiPostPath()
  data class AccountPasswordUpdate(val body: UpdatePasswordRequest) : ApiPostPath()
  data class AccountUserCreate(val body: RegisterRequest) : ApiPostPath()

  data class TicketResaleCreate(val body: CreateResaleRequest) : ApiPostPath()

  data class Track(val body: TrackRequest) : ApiPostPath()
}

sealed class ApiUpdatePath {
  data class CartItemUpdate(val body: ItemUpdateRequest) : ApiUpdatePath()
  data class AccountAddressUpdate(val body: Address) : ApiUpdatePath()
  data class AccountBankDetailsUpdate(val body: BankAccount) : ApiUpdatePath()
  data class AccountCompanyUpdate(val body: CompanyData) : ApiUpdatePath()
  data class AccountUserUpdate(val body: UserData) : ApiUpdatePath()
}

sealed class ApiDeletePath {
  data class AccountAddressDelete(val addressId: Int) : ApiDeletePath()
  data class AccountBankDelete(val bankAccountId: Int) : ApiDeletePath()
  data object AccountUserDelete : ApiDeletePath()
  data class TemplateConfigDelete(val templateId: Uuid) : ApiDeletePath()
  data class TicketResaleDelete(val resaleId: Int) : ApiDeletePath()
}
